interface KVStrPair {
  [key: string]: string;
}

export interface CorpWebIndicatorConfig {
  url: string;
  indicatorName: string;
  indicatorValue: string;
  whitelistRegExp: string[];
}

export function addCorpWebIndicator({
  url,
  indicatorName,
  indicatorValue,
  whitelistRegExp,
}: CorpWebIndicatorConfig): string {
  if (
    !url ||
    !indicatorName ||
    !indicatorValue ||
    !isWhitelistedUrl(url, whitelistRegExp)
  ) {
    return url;
  }
  const param: KVStrPair = { key: indicatorName, value: indicatorValue };
  return appendQueryParamToUrl(url, [param]);
}

function isWhitelistedUrl(url: string, whitelistRegExp: string[]): boolean {
  if (!url || !whitelistRegExp || whitelistRegExp.length === 0) {
    return false;
  }
  for (let i = 0; i < whitelistRegExp.length; i++) {
    const regexp = new RegExp(whitelistRegExp[i], 'g');
    if (url.match(regexp)) {
      return true;
    }
  }
  return false;
}

function appendQueryParamToUrl(url: string, params: KVStrPair[]): string {
  if (!url || !params || params.length === 0) {
    return url;
  }
  params.forEach((pair) => {
    if (pair.key && pair.value) {
      const key = pair.key;
      const value = pair.value;
      const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
      const separator = url.indexOf('?') !== -1 ? '&' : '?';
      if (url.match(re)) {
        url = url.replace(re, '$1' + key + '=' + value + '$2');
      } else {
        url = url + separator + key + '=' + value;
      }
    }
  });
  return url;
}

export function passPath(url: string, path: string) {
  const pathParent = url.split('/')[0];

  const pathname = url.split('/').slice(1).join('/');

  console.log(`${pathParent}${path}/${pathname}`);

  if (window.location.pathname.includes(path)) {
    return `${pathParent}${path}/${pathname}`;
  } else {
    return url;
  }

  return url;
}
